import { SYNC_MARK_URL } from "@/components/Logo";

// Site-wide bolt watermark. Uses the transparent PNG directly — no mask
// needed, no rectangle halo. Fixed, centered, non-interactive, ~6% opacity.
export default function Watermark() {
  return (
    <div
      aria-hidden
      data-testid="site-watermark"
      className="fixed inset-0 z-[3] pointer-events-none flex items-center justify-center"
    >
      <img
        src={SYNC_MARK_URL}
        alt=""
        draggable={false}
        style={{ opacity: 0.06 }}
        className="w-[75vmin] h-[75vmin] object-contain select-none"
      />
    </div>
  );
}
